"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestClient = void 0;
var helpers_1 = require("../helpers");
var types_1 = require("../types");
var helpers_2 = require("../../helpers");
var RequestClientConfig_1 = __importDefault(require("./RequestClientConfig"));
var requestClient = function (_a) {
    var baseUrl = _a.baseUrl;
    function get(getRequestArgs, requestOptionsInit) {
        return __awaiter(this, void 0, void 0, function () {
            var result, success, response, error, error_1;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getUrl(getRequestArgs, requestOptionsInit)];
                    case 1:
                        result = _c.sent();
                        success = result.success, response = result.response, error = result.error;
                        if (!success) {
                            (_a = console === null || console === void 0 ? void 0 : console.networkLogError) === null || _a === void 0 ? void 0 : _a.call(console, "RequestClient=> ", getRequestArgs, result);
                            throw new Error(error !== null && error !== void 0 ? error : "An unexpected error occurred. Please try again.");
                        }
                        return [2 /*return*/, response];
                    case 2:
                        error_1 = _c.sent();
                        (_b = console === null || console === void 0 ? void 0 : console.networkLogError) === null || _b === void 0 ? void 0 : _b.call(console, "RequestClient=> ", error_1);
                        throw new Error((0, helpers_1.isNetworkError)(error_1 === null || error_1 === void 0 ? void 0 : error_1.message) ? types_1.Message.NetworkError : String(error_1 === null || error_1 === void 0 ? void 0 : error_1.message));
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    var post = function (postRequestArgs, requestOptionsInit) {
        return __awaiter(this, void 0, void 0, function () {
            var result, success, response, error, error_2;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, postUrl(postRequestArgs, requestOptionsInit)];
                    case 1:
                        result = _c.sent();
                        success = result.success, response = result.response, error = result.error;
                        if (!success) {
                            (_a = console === null || console === void 0 ? void 0 : console.networkLogError) === null || _a === void 0 ? void 0 : _a.call(console, "RequestClient=> ", postRequestArgs, result);
                            throw new Error(error !== null && error !== void 0 ? error : "An unexpected error occurred. Please try again.");
                        }
                        return [2 /*return*/, response];
                    case 2:
                        error_2 = _c.sent();
                        (_b = console === null || console === void 0 ? void 0 : console.networkLogError) === null || _b === void 0 ? void 0 : _b.call(console, "RequestClient=> ", error_2);
                        throw new Error((0, helpers_1.isNetworkError)(error_2 === null || error_2 === void 0 ? void 0 : error_2.message) ? types_1.Message.NetworkError : String(error_2 === null || error_2 === void 0 ? void 0 : error_2.message));
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    var del = function (deleteRequestArgs, requestOptionsInit) {
        return __awaiter(this, void 0, void 0, function () {
            var result, success, response, error, error_3;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, deleteUrl(deleteRequestArgs, requestOptionsInit)];
                    case 1:
                        result = _c.sent();
                        success = result.success, response = result.response, error = result.error;
                        if (!success) {
                            (_a = console === null || console === void 0 ? void 0 : console.networkLogError) === null || _a === void 0 ? void 0 : _a.call(console, "RequestClient=> ", deleteRequestArgs, result);
                            throw new Error(error !== null && error !== void 0 ? error : "An unexpected error occurred. Please try again.");
                        }
                        return [2 /*return*/, response];
                    case 2:
                        error_3 = _c.sent();
                        (_b = console === null || console === void 0 ? void 0 : console.networkLogError) === null || _b === void 0 ? void 0 : _b.call(console, "RequestClient=> ", error_3);
                        throw new Error((0, helpers_1.isNetworkError)(error_3 === null || error_3 === void 0 ? void 0 : error_3.message) ? types_1.Message.NetworkError : String(error_3 === null || error_3 === void 0 ? void 0 : error_3.message));
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    var getUrl = function (_a, requestOptionsInit_1) {
        return __awaiter(this, arguments, void 0, function (_b, requestOptionsInit) {
            var key, userId, token, authHeaders, requestType;
            var _c, _d, _e, _f;
            var path = _b.path, queryParams = _b.queryParams, pathParams = _b.pathParams;
            return __generator(this, function (_g) {
                // path params
                if (pathParams) {
                    for (key in pathParams) {
                        path = path.replace(":".concat(key), String(pathParams[key]));
                    }
                }
                userId = (_c = helpers_2.tokenProvider.getToken()) !== null && _c !== void 0 ? _c : "";
                token = (_d = helpers_2.tokenProvider.getToken()) !== null && _d !== void 0 ? _d : "";
                authHeaders = { Authorization: "Bearer ".concat(token), UserId: userId };
                requestType = (_e = requestOptionsInit === null || requestOptionsInit === void 0 ? void 0 : requestOptionsInit.requestType) !== null && _e !== void 0 ? _e : "json";
                return [2 /*return*/, (0, RequestClientConfig_1.default)("".concat(baseUrl).concat(path), __assign(__assign({ method: "get", params: queryParams !== null && queryParams !== void 0 ? queryParams : {} }, requestOptionsInit), { requestType: requestType, headers: __assign(__assign({}, authHeaders), requestOptionsInit === null || requestOptionsInit === void 0 ? void 0 : requestOptionsInit.headers), responseType: (_f = requestOptionsInit === null || requestOptionsInit === void 0 ? void 0 : requestOptionsInit.responseType) !== null && _f !== void 0 ? _f : "json" }))];
            });
        });
    };
    var postUrl = function (_a, requestOptionsInit_1) {
        return __awaiter(this, arguments, void 0, function (_b, requestOptionsInit) {
            var userId, token, headers, requestType;
            var _c, _d, _e;
            var path = _b.path, payload = _b.payload, queryParams = _b.queryParams;
            return __generator(this, function (_f) {
                userId = (_c = helpers_2.tokenProvider.getToken()) !== null && _c !== void 0 ? _c : "";
                token = (_d = helpers_2.tokenProvider.getToken()) !== null && _d !== void 0 ? _d : "";
                headers = {
                    "Content-Type": "application/json",
                    Authorization: "Bearer ".concat(token),
                    UserId: userId,
                };
                requestType = (_e = requestOptionsInit === null || requestOptionsInit === void 0 ? void 0 : requestOptionsInit.requestType) !== null && _e !== void 0 ? _e : "json";
                return [2 /*return*/, (0, RequestClientConfig_1.default)("".concat(baseUrl).concat(path), __assign(__assign({ method: "post" }, requestOptionsInit), { params: queryParams !== null && queryParams !== void 0 ? queryParams : {}, requestType: requestType, body: JSON.stringify(payload !== null && payload !== void 0 ? payload : {}), headers: __assign(__assign({}, headers), requestOptionsInit === null || requestOptionsInit === void 0 ? void 0 : requestOptionsInit.headers) }))];
            });
        });
    };
    var deleteUrl = function (_a, requestOptionsInit_1) {
        return __awaiter(this, arguments, void 0, function (_b, requestOptionsInit) {
            var userId, token, headers, key, requestType;
            var _c, _d, _e;
            var path = _b.path, payload = _b.payload, pathParams = _b.pathParams;
            return __generator(this, function (_f) {
                userId = (_c = helpers_2.tokenProvider.getToken()) !== null && _c !== void 0 ? _c : "";
                token = (_d = helpers_2.tokenProvider.getToken()) !== null && _d !== void 0 ? _d : "";
                headers = {
                    "Content-Type": "application/json",
                    Authorization: "Bearer ".concat(token),
                    UserId: userId,
                };
                // path params
                if (pathParams) {
                    for (key in pathParams) {
                        path = path.replace(":" + key, String(pathParams[key]));
                    }
                }
                requestType = (_e = requestOptionsInit === null || requestOptionsInit === void 0 ? void 0 : requestOptionsInit.requestType) !== null && _e !== void 0 ? _e : "json";
                return [2 /*return*/, (0, RequestClientConfig_1.default)("".concat(baseUrl).concat(path), __assign(__assign({ method: "delete" }, requestOptionsInit), { requestType: requestType, body: JSON.stringify(payload), headers: __assign(__assign({}, headers), requestOptionsInit === null || requestOptionsInit === void 0 ? void 0 : requestOptionsInit.headers) }))];
            });
        });
    };
    return { get: get, post: post, delete: del };
};
exports.requestClient = requestClient;
